export const GET_REFERRAL_HISTORY = 'GET_REFERRAL_HISTORY'
export const GET_REFERRAL_COMMISSION_HISTORY = 'GET_REFERRAL_COMMISSION_HISTORY'